class SalutTooltip extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.recent-salut__info-toggle');
    this.tip = this.querySelector('.recent-salut__tip');
    if (!this.toggle || !this.tip) return;

    this.onToggle = this.onToggle.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get open() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  setOpen(value) {
    this.toggle.setAttribute('aria-expanded', value ? 'true' : 'false');
    this.tip.hidden = !value;
  }

  onToggle(event) {
    event.preventDefault();
    this.setOpen(!this.open);
  }

  onDocumentClick(event) {
    if (this.open && !this.contains(event.target)) this.setOpen(false);
  }

  onKeydown(event) {
    if (event.key !== 'Escape' || !this.open) return;
    this.setOpen(false);
    this.toggle.focus();
  }
}

if (!customElements.get('salut-tooltip')) {
  customElements.define('salut-tooltip', SalutTooltip);
}
